import SubmissionError from '../../../../../../../error/SubmissionError'
import fetch from '../../../../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const reset = ({ commit }) => {
  commit(types.RESET)
}

export const retrieve = ({ commit }, id) => {
  commit(types.TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.SET_ERROR, e.message)
    })
}

export const update = ({ commit, state }) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_LOADING)

  state.retrieved.orderStatus = handleNested(state.retrieved.orderStatus)
  state.retrieved.valueNetto = state.retrieved.valueNetto.toString()
  state.retrieved.valueBrutto = state.retrieved.valueBrutto.toString()
  state.retrieved.positions.forEach(entry => {
    if (entry.discount !== null) {
      entry.discount = entry.discount.toString()
    }
    entry.quantity = parseFloat(entry.quantity)
    entry.pricePerUnitBrutto = entry.pricePerUnitBrutto.toString()
    entry.pricePerUnitNetto = entry.pricePerUnitNetto.toString()
    entry.valueNetto = entry.valueNetto.toString()
    entry.valueBrutto = entry.valueBrutto.toString()
    entry.item = handleNested(entry.item)
    entry.vatRate = handleNested(entry.vatRate)
    entry.measure = handleNested(entry.measure)
  })
  state.retrieved.orderTags = state.retrieved.orderTags.map(entry => {
    return { '@id': entry['@id'], tag: entry.value, idOrder: state.retrieved['@id'], text: entry.text, value: entry.value }
  })
  if (state.retrieved.firm === '') {
    state.retrieved.firm = null
  }
  if (state.retrieved.contractor === '') {
    state.retrieved.contractor = null
  }
  if (state.retrieved.idCase === '') {
    state.retrieved.idCase = null
  }

  return fetch(state.retrieved['@id'], {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/ld+json' }),
    body: JSON.stringify(state.retrieved)
  })
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_UPDATED, data)
      Vue.prototype.$Swal({ // show notification with success
        type: 'success',
        title: Vue.prototype.$lang.t('notifications.update.updatedTitle'),
        showConfirmButton: false,
        timer: 2500
      })
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        // commit(types.SET_ERROR, e.errors._error)
        let errors = ''
        for (let key in e.errors) {
          if (key !== '_error') {
            errors += Vue.prototype.$lang.t('views.exsbmeasure.form.' + key) + ' -  ' + e.errors[key] + '<br />'
          }
        }
        Vue.prototype.$Swal({
          type: 'error',
          title: Vue.prototype.$lang.t('notifications.update.errorTitle'),
          html: errors,
          showConfirmButton: true
        })
        return
      }
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.update.errorTitle'),
        text: e,
        showConfirmButton: true,
        timer: 6000
      })
      // eslint-disable-next-line
      // commit(commit(types.SET_ERROR, e.errors._error))
    })
}

function handleNested (data) {
  if (data instanceof Object) {
    return data['@id']
  } else {
    return data
  }
}

export const updateRetrieved = ({ commit }, updated) => {
  commit(types.UPDATE_RETRIEVED, updated)
}
